import React from 'react';
import {
    useParams
} from "react-router-dom";

import logo from 'assets/img/logo-horizontal.svg';

import Hr from 'components/hr';

import './index.css'

const Header = ({ children }) => {
    const { locale } = useParams();

    return (
        <div className='header'>
            <div className='header__container'>
                <div className='logo-container'>
                    <a href={`/${locale}`}>
                        <img alt='midrive transfer logo' className={'logo'} src={logo} />
                    </a>
                </div>
                <div>
                    {children}
                </div>
            </div>
            <Hr />
        </div>
    );
}

export default Header;